import { FC } from "react";
import { CoverImage } from "@/components";
import Image from "@/assets/cover/news_dbg.webp";
import { useTenantProfilesCount } from "../hooks/useTenantsProfilesCount";
import { Box, Flex, Heading, Spinner, Text } from "@radix-ui/themes";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import { useTenantsPrecisionGameCount } from "../hooks/useTenantsPrecisionGameCount";
import { useTenantsJunctionCount } from "../hooks/useTenantsJunctionCount";

export const AnalyticsOverview: FC = (): JSX.Element => {
  const { data, loading, error } = useTenantProfilesCount();
  const {
    data: count,
    hasWon,
    loading: _loading,
    error: _error,
  } = useTenantsPrecisionGameCount();
  const {
    data: tcl,
    loading: tcl_loading,
    error: tcl_error,
  } = useTenantsJunctionCount();

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <FormErrorMessage text={error.message} isVisible={true} />;
  }

  return (
    <>
      <CoverImage
        src={Image}
        alt="CoverImage"
        heading="Analytics"
        desc="Gamebox Festival 2025"
      />
      <Flex direction="column" gap="8">
        <Box>
          <Heading as="h2" size="4">
            Antal signups
          </Heading>
          <Text size="3">{Number(data)}</Text>
        </Box>
        <Box>
          <Heading as="h2" size="4">
            PS Competition signups
          </Heading>
          <Text size="3">{Number(count)}</Text>
        </Box>
        <Box>
          <Heading as="h2" size="4">
            PS5 Competition signups who has hit 1337
          </Heading>
          <Text size="3">{Number(hasWon)}</Text>
        </Box>
        <Box>
          <Heading as="h2" size="4">
            TCL Time Trial Participants
          </Heading>
          <Text size="3">{Number(tcl)}</Text>
        </Box>
      </Flex>
    </>
  );
};

export default AnalyticsOverview;
